// extracted by mini-css-extract-plugin
module.exports = {"section":"ErrorPromo_section__r26YN","heading":"ErrorPromo_heading__5uo_K","subheading":"ErrorPromo_subheading__icg_B"};